<div class="container-fluid py-3 py-md-4">
  <!-- =====================================
DASHBOARD HEADER
===================================== -->

  <div
    class="card dashboard-topbar p-3 d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 mb-4">

    <!-- LEFT -->

    <div>

      <h3 class="fw-bold m-0">

        🏠 Dashboard

      </h3>

      <small class="text-muted">

        Bird’s eye view of your business

      </small>

    </div>

    <!-- RIGHT LOW STOCK ALERTS -->
    <div class="d-flex align-items-center flex-wrap gap-2">

      <!-- LIGHT LABEL -->

      <div class="alert-title">

        Low Stock Alerts Here

      </div>

      <!-- ALERTS -->

      <div class="mini-alert" *ngFor="let item of dashboardData?.lowStockProducts || []">

        <span class="dot"></span>

        <span>

          {{ item.name }}

          :

          {{ item.currentStock }}

        </span>

      </div>

    </div>

  </div>

  <div class="dashboard-wrapper">

    <!-- =====================================  
    STATS CARDS
    ===================================== -->

    <div class="row g-4">

      <!-- TOTAL PRODUCTS -->

      <div class="col-xl-3 col-md-6">

        <div class="stats-card products-card">

          <div class="stats-icon">

            <i class="ri-shopping-bag-3-line"></i>

          </div>

          <div class="stats-content">

            <span>Total Products</span>

            <h3>
              {{ dashboardData?.totalProducts || 0 }}
            </h3>

          </div>

        </div>

      </div>

      <!-- TOTAL INVOICES -->

      <div class="col-xl-3 col-md-6">

        <div class="stats-card invoice-card">

          <div class="stats-icon">

            <i class="ri-file-list-3-line"></i>

          </div>

          <div class="stats-content">

            <span>Total Invoices</span>

            <h3>
              {{ dashboardData?.totalInvoices || 0 }}
            </h3>

          </div>

        </div>

      </div>

      <!-- TOTAL SALES -->

      <div class="col-xl-3 col-md-6">

        <div class="stats-card sales-card">

          <div class="stats-icon">

            <i class="ri-money-dollar-circle-line"></i>

          </div>

          <div class="stats-content">

            <span>Total Sales</span>

            <h3>
              Rs {{ dashboardData?.totalSales || 0 }}
            </h3>

          </div>

        </div>

      </div>

      <!-- TOTAL STOCK -->

      <div class="col-xl-3 col-md-6">

        <div class="stats-card stock-card">

          <div class="stats-icon">

            <i class="ri-stack-line"></i>

          </div>

          <div class="stats-content">

            <span>Total Stock</span>

            <h3>
              {{ dashboardData?.totalStock || 0 }}
            </h3>

          </div>

        </div>

      </div>

    </div>


  </div>

</div>